import PropTypes from 'prop-types';

const Label = ({ type, text, marginLeft }) => {
  let color;
  const isSpecial = text === 'Special' || text === 'Suggested Look';
  switch (type) {
    case 'red':
      color = '#ff0000';
      break;
    case 'blue':
      color = '#4A90E2';
      break;
    case 'grey':
      color = '#646464';
      break;
    case 'orange':
      color = '#C44700';
      break;
    case 'green':
      color = '#509508';
      break;
    case 'purple':
      color = '#9508b9';
      break;
    case 'yellow':
      color = '#C49000';
      break;
    default:
      color = '#950810';
  }
  return (
    <>
      <span className="label">
        {text.toUpperCase()}
        {isSpecial && (
          <>
            <div className="star star-1">
              <img
                src={
                  'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Star_1.png?v=1716896323'
                }
                width={12}
                height={12}
              />
            </div>
            <div className="star star-2">
              <img
                src={
                  'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Star_1.png?v=1716896323'
                }
                width={8}
                height={8}
              />
            </div>
          </>
        )}
      </span>

      <style jsx>
        {`
          .label {
            margin-left: ${marginLeft};
            height: 16px;
            background-color: ${color};
            font-size: 10px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 16px;
            border-radius: 2px;
            padding: 3px 6px;
            white-space: nowrap;
            position: relative;
          }
          .star {
            position: absolute;
          }
          .star-1 {
            top: -8px;
            right: 1px;
          }
          .star-2 {
            top: -4px;
            right: -4px;
          }
        `}
      </style>
    </>
  );
};

Label.propTypes = {
  type: PropTypes.oneOf(['red', 'blue', 'grey', 'orange', 'green', 'yellow']),
  text: PropTypes.string.isRequired,
  marginLeft: PropTypes.string,
};

Label.defaultProps = {
  type: 'red',
  marginLeft: '6px',
};
export default Label;
